
import { defineComponent } from "vue";
import PublicPage from "@/views/public/PublicPage.vue";

export default defineComponent({
  name: "about-page",
  components: { PublicPage },
  setup() {
    const features = [
      {
        title: "Tüm platformlar tek panelde",
        desc: "Bağlı tüm hesaplarınızı tek ekrandan görün ve yönetin.",
      },
      {
        title: "Ürün aç/kapat",
        desc: "Tükenen ürünleri tek dokunuşla tüm platformlarda kapatıp açın.",
      },
      {
        title: "Hızlı fiyat güncelleme",
        desc: "Tek tek veya toplu; yüzde ya da tutar bazlı zam/indirim uygulayın.",
      },
      {
        title: "Mağaza aç/kapat",
        desc: "Yoğunlukta veya molada mağazanızı anında durdurun.",
      },
      {
        title: "Yorum yönetimi",
        desc: "Müşteri yorumlarını tek yerden okuyun ve anında cevap verin.",
      },
      {
        title: "Akıllı gruplar & zamanlama",
        desc: "Ürünleri gruplayın, belirli saatlerde otomatik aç/kapat kurun.",
      },
    ];
    return { features };
  },
});
